export const SELECTED_SECTION = 'SELECTED_SECTION';
